import React from 'react'
import styled from 'styled-components'
import { useFirebaseConnect, useFirebase } from 'react-redux-firebase'
import { getFormatedData } from '../functions/getFormatedData'
import { useSelector } from 'react-redux'
import { Loading } from '../components/UI/Loading'
import { colors } from '../styles/colors'

const Container = styled.div`
    width: 100%;
    .preloader {
        display:flex;
        justify-content: center;
    }
    .order-list-is-empty {
        text-align: center;
    }
`

const OrderContainer = styled.div`
    max-width: 640px;
    width: 100%;

    position: relative;

    padding: 4rem 2rem ;
    margin: 0 auto 5rem auto;

    border: 1px solid ${colors.dark_blue};

    @media (min-width: 500px) {
        padding: 4rem 6rem ;
    }

    .status {
        position: absolute;
        top: 2rem;
        right: 2rem;
        color: green;
    }
    .contacts {
        margin-bottom: 2rem;
    }
    .title {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 400;
        font-size: 3rem;
        color: ${colors.dark_blue};
        margin-bottom: 2rem;
    }
    .text,
    .delete-order-button,
    .change-status-button {
        font-family: 'SF UI Text', sans-serif;
        font-weight: 300;
        font-size: 2.25rem;
        line-height: 150%;
        color: ${colors.dark_blue};
    }
    .buttons {
        display: flex;
        justify-content: space-between;

        margin-top: 3rem;

    }
    .delete-order-button,
    .change-status-button {
        font-size: 2rem;
        cursor: pointer;
    }
    .delete-order-button {
        :hover {
            color: ${colors.red};
        }
    }
`

const OrderListItemContainer = styled.div`
    padding: 2rem 0;
    margin: 0 2rem;
    border-bottom: 1px solid ${colors.dark_blue};
`

const ServicesOrderList = ({ list }) => {
    return (
        <>
            {
                list.order.map((item, key) => (
                    <OrderListItemContainer key={key}>
                        <p className='text'><b>Наименование услуги:</b> {item}</p>
                    </OrderListItemContainer>
                ))
            }
        </>
    )
}

const ProductsOrderList = ({ list }) => {
    return (
        <>
            {
                list.order.map((item, key) => (
                    <OrderListItemContainer key={key}>
                        <p className='text'><b>Наименование:</b> {item.product_name}</p>
                        <p className='text'><b>Количество:</b> {item.count} </p>
                    </OrderListItemContainer>
                ))
            }
        </>
    )
}

const Order = ({ data }) => {

    const db = useFirebase()
    const order_in_db = db.ref(`orders/${data.key}`)

    function handleChangeStatus () {
        order_in_db.child('status').set('old')
    }
    function handleDeleteOrder () {
        const del_confirm = window.confirm('Вы действительно хотите удалить заявку?')

        if (del_confirm) {
            order_in_db.remove()
        }
    }

    return (
        <OrderContainer status={data.status} >
            <p className='status'>{data.status === 'new' ? 'Новая' : null}</p>
            <div className="contacts">
                <p className="title">Контактные данные</p>
                <p className='text' > <b>Ф.И.О.:</b> {data.name} </p>
                <p className='text'> <b>Телефон :</b> {data.tel} </p>
                <p className='text'> <b>E-mail :</b> {data.email} </p>
                <p className='text'> <b>Комментарий :</b> {data.description} </p>
            </div>
            <div>{!data.order
                ? <p className="title">Заявка на консультацию</p>
                : data.order[0].product_name
                    ? (
                        <>
                            <p className="title">Заявка на покупку продукции:</p>
                            <ProductsOrderList list={data} />
                        </>
                    )
                    : (
                        <>
                            <p className="title">Заявка на сервисное обслуживание:</p>
                            <ServicesOrderList list={data} />
                        </>
                    )
            }</div>

            <div className="buttons">
                { data.status === 'new' ? <p onClick={()=> handleChangeStatus() } className='change-status-button'>Отметить как просмотренную</p> : <p></p> }
                
                <p onClick={()=> handleDeleteOrder() } className='delete-order-button'>Удалить заявку</p>
            </div>
        </OrderContainer>
    )
}

export const OrderList = () => {
    useFirebaseConnect('orders')
    const orders_fetched_data = getFormatedData(useSelector(state => state.firebase.data.orders))
    return (
        <Container>
            {
                orders_fetched_data
                    ? orders_fetched_data.length !== 0 
                        ? orders_fetched_data.reverse().map((order_data, key) => <Order data={order_data} key={key} />)
                        : <p className='order-list-is-empty'>Пусто</p>
                    : <Loading />
            }
        </Container>
    )
}
